import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";

/*Change Get Api here*/
const getApiWithdrawalHistory = async (query) => {
  return axiosInstance({
    method: "get",
    url: "/withdrawal-histories",
    params: query,
  }).then(handleResponse);
};

/*Change Post Api here*/
const postApiWithdrawalHistory = async (data) => {
  return await axiosInstance.post("/withdrawal-history/for-admin", data).then(handleResponse);
};

/*Change Put Api here*/
const putApiWithdrawalHistory = async (id, data) => {
  return await axiosInstance.put("/withdrawal-history/for-admin", data).then(handleResponse);
};

/*Change Get Api here*/
const deleteApiWithdrawalHistory = async (id, data) => {
  return await axiosInstance.delete("/withdrawal-history/for-admin", data).then(handleResponse);
};

export {
  getApiWithdrawalHistory,
  postApiWithdrawalHistory,
  putApiWithdrawalHistory,
  deleteApiWithdrawalHistory,
};
